import React, {useState,useEffect} from 'react';
import {
  MDBCol,
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBBtn,
  MDBLink,
  MDBView,
  MDBMask,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBRow,
  MDBIcon
} from 'mdbreact';


import TreatmentActions from "./actions/TreatmentActions";
import PermissionHelper from "../../../helpers/PermissionHelper";

import moment from 'moment';
import 'moment/locale/de';




class TreatmentResultRow extends React.Component {

  constructor(props) {
    super(props);
    this._onComplete = this._onComplete.bind(this);
    this._onDelete = this._onDelete.bind(this);
  }

  _onComplete() {
    let component = this;

    let values = {
      nid: this.props.result.nid,
      field_is_completed: 1
    }

    const r = window.confirm("Abschliesen Bestätigen");
    if (r === true) {
      TreatmentActions._patch(values).then(response => {
        component.props.searchComponent.loadTreatmentCollection();
      });
    }


  }

  _onDelete() {
    let component = this;

    const r = window.confirm("Löschen Bestätigen");
    if (r === true) {
      TreatmentActions._delete(this.props.result.nid)
        .then(response => {
          component.props.searchComponent.loadTreatmentCollection();
        });
    }
  }

  render() {
    return (
      <tr>
        <td>{this.props.result.node.field_treatment_number[0].value}</td>
        <td>{moment.unix(this.props.result.created).format("DD.MM.YYYY HH:mm")}</td>
        <td>{this.props.result.treatment_type.name[0].value}</td>

        <td className="text-right">

          <div className="action-bar">



            {false && PermissionHelper._hasPermission('restful patch Treatment') === true &&
              <>
                {this.props.result.node.field_is_completed[0].value == '0' &&
                  <MDBBtn color="green" className="btn-details" onClick={this._onComplete} className="mr-2"><MDBIcon far icon="check-square" /></MDBBtn>
                }
              </>
            }


            <MDBLink to={`/treatment/${this.props.result.nid}`} className="d-inline mr-2">
              <MDBBtn color="primary" className="btn-details" className="mr-2"><MDBIcon icon="bars" /></MDBBtn>
            </MDBLink>

            {PermissionHelper._hasPermission('restful delete Treatment') === true &&
              <>
                <MDBBtn color="red" className="btn-delete" onClick={this._onDelete} className="mr-2"><MDBIcon far icon="trash-alt" /></MDBBtn>
              </>
            }

          </div>


        </td>
      </tr>
    );
  }
}

export default TreatmentResultRow;
